import React from 'react';
import Zoom from 'react-medium-image-zoom'

import { ImageListItem, Box } from '@mui/material';

import ShopConfig from '../../../api/config/shopConfig';
import QVContainer from './QVContainer';

export default function MasonryImageItem(props) {
    const { item } = props;
    
    return (
        <ImageListItem key={item}>
            <Zoom zoomMargin={20} zoomImg={{src: ShopConfig.config().getURLForZoomedProductImage(item)}}>
                <QVContainer
                    borderRadius={12}
                    padding={0}
                    sx={{
                        width: 280,
                        height: 280,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        overflow: 'hidden'
                    }}
                >
                    <Box
                        component="img"
                        width="280px"
                        height="280px"
                        alt="product.name"
                        src={ShopConfig.config().getURLForProductImage(item)}
                        sx={{
                            objectFit: 'contain',
                            objectPosition: 'center'
                        }}
                    />
                </QVContainer>
            </Zoom>
        </ImageListItem>
    )
}
